import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ShieldCheck } from 'lucide-react';

const VerificationCallout: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="bg-blue-50 border border-blue-200 rounded-lg p-5 text-center"
      data-testid="verification-callout"
    >
      <ShieldCheck className="h-8 w-8 text-blue-400 mx-auto mb-2" />
      <p className="text-sm font-medium text-blue-900 mb-1">
        Verify your work email to participate
      </p>
      <p className="text-xs text-blue-700 mb-3">
        Verified professionals can post, comment, and react in discussions.
      </p>
      <Button
        size="sm"
        onClick={() => navigate('/verification')}
        data-testid="verify-cta-btn"
      >
        <ShieldCheck className="h-4 w-4 mr-1.5" />
        Get Verified
      </Button>
    </div>
  );
};

export default VerificationCallout;
